import {ColumnModel} from './ColumnModel';
export class CollapsableModel {
    title:string;
    subtitle?:string;
    columns:ColumnModel[];
    actions:string[];
    mobileActions?:string[];
    headerIcon?:string;
    headerIconSearch?:string;
    layoutType?: "Custom" |  "FormRead" | "FormEdit" |  "SearchBar"|  null  ; 
    filter?: string ;
    filterValue?: string;
    titleValue?: string;
    data:string;
    dotColor?:string;
    textOrRow?:boolean;
    link1:string;
    link2:string;
    
  }
  
 